import { render, staticRenderFns } from "./CosmoClawProcessTrace.vue?vue&type=template&id=82c97d02&scoped=true"
import script from "./CosmoClawProcessTrace.vue?vue&type=script&lang=js"
export * from "./CosmoClawProcessTrace.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawProcessTrace.vue?vue&type=style&index=0&id=82c97d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c97d02",
  null
  
)

export default component.exports